import { jsx as _jsx } from "react/jsx-runtime";
import { isSocialBrowser } from "@faire/retailer-visitor-shared/lib/user-agent/isSocialBrowser";
import { isWebView } from "@faire/retailer-visitor-shared/lib/user-agent/isWebView";
import { Apple } from "@faire/web--source/slate/icons/external/Apple";
import { Google } from "@faire/web--source/slate/icons/external/Google";
import { Lock } from "@faire/web--source/slate/icons/foundation/Lock";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { ISignUpSuggestions } from "@faire/web-api--source/indigofair/data/ISignUpSuggestions";
import { SocialSignOnProvider } from "@faire/web-api--source/indigofair/data/SocialSignOnProvider";
import React from "react";
export var PROFILE_IMAGE_SIZE = 64;
export var getSocialProviderText = function(socialProvider) {
    switch(socialProvider){
        case SocialSignOnProvider.GOOGLE:
            return "Google";
        case SocialSignOnProvider.APPLE:
            return "Apple";
        case SocialSignOnProvider.OKTA:
            return "Okta";
        default:
            return "";
    }
};
export var getSocialProviderLogo = function(socialProvider) {
    switch(socialProvider){
        case SocialSignOnProvider.GOOGLE:
            return /*#__PURE__*/ _jsx(Google, {
                fontSize: "20px"
            });
        case SocialSignOnProvider.APPLE:
            return /*#__PURE__*/ _jsx(Apple, {
                fontSize: "20px"
            });
        case SocialSignOnProvider.OKTA:
            return /*#__PURE__*/ _jsx(Lock, {
                lockType: "circle",
                fontSize: "20px"
            });
        default:
            return null;
    }
};
export var showSSOButtons = function() {
    return !isSocialBrowser() && !isWebView();
};
export var showSSOButtonsOnSignIn = function() {
    return !isSocialBrowser() && !isWebView();
};
export var getPayloadForConfirmPassword = function(signUpSuggestions) {
    var _ref = signUpSuggestions !== null && signUpSuggestions !== void 0 ? signUpSuggestions : ISignUpSuggestions.build({}), email_address = _ref.email_address, first_name = _ref.first_name, last_name = _ref.last_name, profile_image_url = _ref.profile_image_url;
    return {
        email: email_address,
        userName: first_name && last_name ? "".concat(first_name, " ").concat(last_name) : undefined,
        profileImage: IImage.build({
            url: profile_image_url,
            width: PROFILE_IMAGE_SIZE,
            height: PROFILE_IMAGE_SIZE
        })
    };
};
